export default "__VITE_ASSET__8ce7a5eb__"